const localePt = {
  pt: {
    BREADCRUMB_1: 'Home',
    BREADCRUMB_2: 'Downloadable',

    RESOURCE_NEW: 'Novo',
    RESOURCE_DOWNLOADS: 'downloads',
    RESOURCE_DOWNLOAD_BUTTON: 'Baixar',

    UNLOCKED_TITLE: 'Obrigado por se inscrever!',
    UNLOCKED_SUBTITLE: 'Agora comece a desfrutar deste recurso.',

    FORM_TITLE_1: 'Registre-se',
    FORM_TITLE_2: 'para',
    FORM_TITLE_3: 'baixar este recurso',
    FORM_NAME: 'Nome',
    FORM_LASTNAME: 'Sobrenome',
    FORM_EMAIL: 'Email',
    FORM_COMPANY: 'Nome da sua empresa',
    FORM_BUTTON: 'Registre-se',
    FORM_ERROR_REQUIRED: 'Campo obrigatório',
    FORM_ERROR_MAX_LENGTH: 'Máximo 50 caracteres',
    FORM_ERROR_EMAIL: 'Por favor, insira um email válido.',
    FORM_ERROR_LABEL: 'Erro',
    FORM_RECOMMENDATIONS_TITLE:
      'Você também pode estar interessado nestes recursos',
    FORM_FIELD_ORG_SIZE: 'Tamanho da empresa',
    FORM_COMPANY_SIZE_250: 'Até 250 colaboradores',
    FORM_COMPANY_SIZE_1000: 'De 1001 a mais',
    FORM_COMPANY_SIZE_MORE_250: 'De 251 a 1000 pessoas',
    FORM_PHONE_LABEL: 'Número de telefone',
    FORM_SELECT: 'Seleccione',
    SHARE_RESOURCE: 'Compartilhe este artigo',
  },
};

export default localePt;
